import React from "react";
import { ArrowRight, HeartHandshake, Users, Activity, House, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Landscape Design",
  description: "Our expert team creates comprehensive architectural plans that blend native flora with sustainable practices for a timeless outdoor aesthetic.",
  icon: HeartHandshake,
  link: "/ServicesPage",
  colSpan: "md:col-span-6"
}, {
  title: "Seasonal Clean-ups",
  description: "Meticulous spring and fall maintenance to protect your property's health and ensure your landscape remains pristine throughout the changing seasons.",
  icon: Users,
  link: "/ServicesPage",
  colSpan: "md:col-span-6"
}, {
  title: "Lawn Maintenance",
  description: "Professional turf management including precision mowing,\xA0 fertilization, and aeration to cultivate a lush, vibrant green carpet for your home.",
  icon: Activity,
  link: "/ServicesPage",
  colSpan: "md:col-span-4"
}, {
  title: "Hardscape Installation",
  description: "Precision-engineered patios, walkways, and retaining walls crafted from premium materials to extend your living space into the great outdoors.",
  icon: House,
  link: "/ServicesPage",
  colSpan: "md:col-span-4"
}];
export default function OurServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="39166" id="services-list" className="bg-background py-20 relative overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4">
        <div className={`text-center mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4 font-default tracking-tight">
            Our Professional Services
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-default">
            Transforming Rockland and Orange County landscapes through meticulous design, sustainable practices, and architectural precision.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {services.map((service, i) => <div key={i} data-index={i} className={cn("h-full transition-all duration-700 delay-[100ms]", service.colSpan, isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10')} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="h-full border-border bg-card shadow-sm hover:shadow-md transition-all duration-300 hover:rotate-1 group flex flex-col justify-between overflow-hidden rounded-sm">
                <CardHeader className="pb-2">
                  <div className="mb-4 w-fit p-2 rounded-sm transition-all duration-300 group-hover:drop-shadow-[0_0_8px_var(--color-chart-2)]">
                    <service.icon className="w-10 h-10 text-chart-2" strokeWidth={2} />
                  </div>
                  <CardTitle className="text-xl font-bold text-primary font-default">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-muted-foreground text-base leading-relaxed font-default">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-4 mt-auto">
                  <Link to={service.link} className="inline-flex items-center text-chart-2 font-semibold group/link hover:text-chart-2/80 transition-colors font-default">
                    View Details
                    <ArrowRight className="ml-2 w-4 h-4 text-chart-2 transition-transform duration-300 group-hover/link:translate-x-1" />
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}